import React from "react";

const RawHtml = ({ children = "", tag: Tag = "div", ...props }) => (
  <Tag {...props} dangerouslySetInnerHTML={{ __html: children }} />
);

export { RawHtml };
